import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import pressImage from 'images/team/product_tour.svg'
import aboutImage from 'images/team/augmented_reality.svg'
import headerImage from 'images/team/virtual_reality.svg'

import { LessThanBreakpoint, MoreThanBreakpoint } from 'Utils/GetBreakpoint'

import Header from './Components/Header'
import Investors from './Components/Investors'
import Contacts from './Components/Contacts'
import InfoSection from './Components/InfoSection'

class AboutUs extends React.Component {
  constructor() {
    super()

    this.state = {
      isMobile: true,
      isContactsSectionLink: false,
      shouldScrollOnUpdate: false,
      scrollOffset: 60,
    }

    this.contactsSection = React.createRef()
  }

  componentDidMount() {
    const { location } = this.props
    this.handleWindowSizeChange()

    this.setState({ scrollOffset: document.getElementById('navigation-header').clientHeight })

    if (location.hash) {
      this.setState({ isContactsSectionLink: true, shouldScrollOnUpdate: true })
      this.scrollToContacts()
    }

    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentDidUpdate() {
    const { location } = this.props
    const { isContactsSectionLink, shouldScrollOnUpdate } = this.state

    if (location.hash && isContactsSectionLink && shouldScrollOnUpdate) {
      this.setState({ shouldScrollOnUpdate: false })
      this.scrollToContacts()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  scrollToContacts = () => {
    this.contactsSection.current.scrollIntoView({ block: 'center' })
  }

  handleWindowSizeChange = () => {
    const { isMobile } = this.state

    if (LessThanBreakpoint('lg') && !isMobile) {
      this.setState({ isMobile: true })
    } else if (MoreThanBreakpoint('md') && (isMobile)) {
      this.setState({ isMobile: false })
    }
  }

  render() {
    const {
      modelsCount,
      designersCount,
    } = this.props
    const {
      isMobile,
    } = this.state
    const pressData = {
      id: 'about-press-section',
      image: pressImage,
      altText: 'product tour',
      title: 'News',
      text: `Keep up to date with the latest news and views from CGTrader - covering our latest customer stories, 
      event participation, product news and company milestones.`,
      linkText: 'Go to our Blog',
      link: '/blog',
    }
    const aboutData = {
      id: 'about-about-section',
      sectionClassName: ' info-section--white',
      image: aboutImage,
      altText: 'augmented reality',
      title: 'Our story',
      text: `CGTrader was founded in 2011 by Marius Kalytis, an experienced 3D designer himself, to be the first 
      designer-friendly online marketplace for buying, selling and creating professional 3D content.`,
    }
    const headerData = {
      image: headerImage,
      altText: 'virtual reality',
      modelsCount,
      designersCount,
    }
    const { scrollOffset } = this.state

    return (
      <Fragment>
        <Header scrollOffset={-scrollOffset} {...headerData} />
        <InfoSection {...aboutData} />
        <Investors id="about-investors-section" isMobile={isMobile} />
        <InfoSection {...pressData} />
        <div ref={this.contactsSection}>
          <Contacts id="about-contact-section" />
        </div>
      </Fragment>
    )
  }
}

AboutUs.propTypes = {
  modelsCount: PropTypes.number.isRequired,
  designersCount: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
}

export default AboutUs
